import { useQuery } from '@tanstack/react-query';
import { getPaymentAggregators, getSiteUrls } from './endpoints';
import { apiKeys } from './keys';
import { isWixPaymentProviderSupported } from '../utils/payment';
import {
  GetPaymentAggregateResponse,
  GetMetaSiteUrlsResponse,
} from '@wix/ambassador-gg-store-setup-v1-store-setup-service/types';

export function usePaymentProviders() {
  return useQuery<GetPaymentAggregateResponse, Error, { providers: GetPaymentAggregateResponse; isAvailable: boolean }>(
    {
      queryKey: apiKeys.queries.getPaymentAggregators(),
      queryFn: () => getPaymentAggregators(),
      staleTime: 5 * 60 * 1000,
      select: (data) => ({
        providers: data,
        isAvailable: isWixPaymentProviderSupported(data),
      }),
    },
  );
}

export function useSiteUrls() {
  return useQuery<GetMetaSiteUrlsResponse, Error, string>({
    queryKey: apiKeys.queries.getSiteUrls(),
    queryFn: () => {
      return getSiteUrls();
    },
    select: (siteUrls: GetMetaSiteUrlsResponse) => siteUrls?.metaSiteUrls?.primary?.url || '',
    staleTime: 5 * 60 * 1000,
    retry: 3,
    retryDelay: 2000,
  });
}
